import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "section-title" }
const _hoisted_2 = { class: "row-value" }
const _hoisted_3 = { class: "row-price" }
const _hoisted_4 = {
  key: 1,
  class: "section-content"
}
const _hoisted_5 = { class: "row-value" }
const _hoisted_6 = { class: "row-price" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["section-row", { mobile: $props.isMobile }])
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString($props.title), 1),
    ($setup.isUpgradeSection && $props.value)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($props.value, (upgrade, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "section-content",
            key: upgrade._id
          }, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(upgrade.name), 1),
            _createElementVNode("div", _hoisted_3, _toDisplayString($setup.formatPrice(upgrade.price)), 1)
          ]))
        }), 128))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString($props.value || "-"), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString($setup.formatPrice($props.price)), 1)
        ]))
  ], 2))
}